import { SET_USER_MOBILE_TOKEN, SET_USER_PARAMETERS } from "../action-types/authentication";

const initialState = {
    userId: null,
    formId: null,
    organicUnits: [],
    registrationRef: null,
    registrationState: null,
    registrationApproved: true,
    mbPending: false,
    mbwayPending: false,
    brainAnswerAccess: false,
    comissionAccess: false,
    hasSignatureCredits: false,
    internal: false,
    mobileAuthToken: null
};

const authenticationReducer = (state = initialState, action) => {
    switch(action.type) {
        case SET_USER_PARAMETERS:
            return {
                ...state,
                userId: action.userId,
                formId: action.formId,
                organicUnits: action.organicUnits,
                registrationRef: action.registrationRef,
                registrationState: action.registrationState,
                registrationApproved: action.registrationApproved,
                mbPending: action.mbPending,
                mbwayPending: action.mbwayPending,
                brainAnswerAccess: action.brainAnswerAccess,
                comissionAccess: action.comissionAccess,
                hasSignatureCredits: action.hasSignatureCredits,
                internal: action.internal
            };
        case SET_USER_MOBILE_TOKEN:
            return {
                ...state,
                mobileAuthToken: action.mobileAuthToken
            };
        default:
            return state;
    }
}

export default authenticationReducer;